import type { DealEstimation } from '~/models/DealEstimate';
import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';
import type {
  DealConstruction,
  DealConstructionEdit
} from '~/models/DealConstruction';

const paths = {
  create: '/deals/:deal_id/deal_own_estimations',
  update: '/deals/:deal_id/deal_own_estimations/:id',
  destroy: '/deals/:deal_id/deal_own_estimations/:id',
  updateSeq: '/deals/:deal_id/deal_own_estimations/update_seq'
};

export const create = async (
  dealEstimation: DealConstructionEdit,
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.create.replace(':deal_id', String(dealId)), {
    dealEstimation
  });

export const update = async (
  dealEstimation: DealConstructionEdit,
  dealEstimationId: number,
  dealId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update
      .replace(':id', String(dealEstimationId))
      .replace(':deal_id', String(dealId)),
    { dealEstimation }
  );

export const destroy = async (
  dealEstimation: DealEstimation,
  dealId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    paths.destroy
      .replace(':id', String(dealEstimation.id))
      .replace(':deal_id', String(dealId))
  );

export const updateSeq = async (
  dealEstimations: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.updateSeq.replace(':deal_id', String(dealId)), {
    dealEstimations
  });
